import React, { Component } from 'react';
import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs';
import '../StepByStep.css';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemPanel,
    AccordionItemButton
} from 'react-accessible-accordion';
import Printer from '../../shared/printer/printer';

class ImageValidator extends Component {
    render() {
        const subscriberQueues = process.env.BASE_URL + "images/guides/ImageValidator_Queue.png";
        const imgChecking = process.env.BASE_URL + "images/guides/ImageValidator_ImageChecking.png";
        const imgStatus = process.env.BASE_URL + "images/guides/ImageValidator_Status.png";
        const searchWeb = process.env.BASE_URL + "images/guides/ImageValidator_SearchWeb.png";
        const imgResult = process.env.BASE_URL + "images/guides/ImageValidator_ImageResult.png";
        const imgFinal = process.env.BASE_URL + "images/guides/ImageValidator_Final.png";
        return (
            <div className="step-main">
                <div className="bread-print-container">
                    <Breadcrumbs />
                    <Printer parentContainer="validatorContainer" />
                </div>
                <div id="validatorContainer" className="step-content">
                    <h1 className="step-heading">A step-by-step guide to ImageValidator</h1>
                    <p></p>
                    <Accordion preExpanded={[`background`]} allowMultipleExpanded="true">
                        <AccordionItem uuid="background" className="accordion-first-item">
                            <AccordionItemHeading aria-level={2}>
                                <AccordionItemButton className="accordion-background">
                                    Background
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel className="accordion-panel">
                                <div className="step-main-content">
                                    <p>Beginning in 2003 Thales pioneered the technology
                                        around how images are reviewed for content, originality and
                                        suitability to card issuers and associated networks.</p>
                                    <p>By providing an easy to use online decision platform we have
                                        made the challenge of evaluating millions of images simple
                                        and efficient for our clients.</p>
                                    <p><b>ImageValidator</b> is the next step in offering the ultimate
                                        assistance to image checkers. By providing an unparalleled
                                        resource, <b>ImageValidator</b> raises the level of intelligence and
                                        confidence surrounding how an image is checked and
                                        ultimately determined.</p>
                                </div>
                            </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem uuid="introduction">
                            <AccordionItemHeading aria-level={2}>
                                <AccordionItemButton className="accordion-background">
                                    What is it?
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel className="accordion-panel">
                                <div className="step-main-content">
                                    <p><b>ImageValidator</b> is a premium online image checking tool available to
                                        extend the knowledge of image content origins. Use of <b>ImageValidator</b>
                                        will result in greater certainty and consistency in the image checking
                                        process.</p>
                                    <p>By using a reverse image search engine ImageValidator :</p>
                                    <ul>
                                        <li><p>Indicates whether that image has been image checked before</p></li>
                                        <li><p>Informs image checker of all previous decisions made for that image if it has been checked before</p></li>
                                        <li><p>Searches the internet for other instances of the uploaded card image and provides links to any found images</p></li>
                                    </ul>
                                </div>
                            </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem uuid="working">
                            <AccordionItemHeading aria-level={2}>
                                <AccordionItemButton className="accordion-background">
                                    How it works?
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel className="accordion-panel">
                                <div className="stepbystep-content-display">
                                    <img className="stepbystep-image-alignment stepbystep-image-size" src={subscriberQueues} alt="Subscriber Queue" />
                                    <div className="step-main-content stepbystep-content-alignment">
                                        <p><b>ImageValidator</b> is built into the Image checking administration site.</p>
                                        <p>The associated icon appears below the options in image queue.</p>
                                        <p>When you click on the ImageValidator icon the technology will return all previously reviewed associated designs (the actual card designs does not have to be 100% the same).</p>
                                    </div>
                                </div>
                                <div className="stepbystep-content-display">
                                    <img className="stepbystep-image-alignment stepbystep-image-size" src={imgChecking} alt="Image Validator" />
                                    <div className="step-main-content stepbystep-content-alignment">
                                    <p>In the first search ImageValidator is checking to see if the image appeared in any previous image checking decisions</p>
                                        <p>Information provided includes</p>
                                       <ul>
                                           <li><p>the actual design reviewed</p></li>
                                           <li><p>the date &amp; time design was reviewed</p></li>
                                           <li><p>Icon indicating state or decision made in previous review</p></li>
                                       </ul>
                                    </div>
                                </div>
                                <div className="stepbystep-content-display">
                                    <img className="stepbystep-image-alignment stepbystep-image-size" src={imgStatus} alt="Image Checking Status" />
                                    <div className="step-main-content stepbystep-content-alignment">
                                    <p>When you click on the State Icon (cross, tick or audit glasses) next to the previous decision, you will go to the audit view for that image result for more information</p>
                                    </div>
                                </div>
                                <div className="stepbystep-content-display">
                                    <img className="stepbystep-image-alignment stepbystep-image-size" src={searchWeb} alt="Web Search" />
                                    <div className="step-main-content stepbystep-content-alignment">
                                    <p>When you click on ‘Search Web’ - you will search the internet for a match of the image</p>
                                    </div>
                                </div>
                                <div className="stepbystep-content-display">
                                    <img className="stepbystep-image-alignment stepbystep-image-size" src={imgResult} alt="Image Result" />
                                    <div className="step-main-content stepbystep-content-alignment">
                                    <p>At the web search you can click on the link to go to the page or the image ImageValidator has found</p>
                                    </div>
                                </div>
                                <div className="stepbystep-content-display">
                                    <img className="stepbystep-image-alignment stepbystep-image-size" src={imgFinal} alt="Image Result" />
                                    <div className="step-main-content stepbystep-content-alignment">
                                    <p>Now that you have completed <b>ImageValidator</b> searches you have the information necessary to make the appropriate decision. In this case deny for copyright infringement.</p>
                                    </div>
                                </div>
                            </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem uuid="benefits">
                            <AccordionItemHeading aria-level={2}>
                                <AccordionItemButton className="accordion-background">
                                What are the key benefits?
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel className="accordion-panel">
                                <div className="step-main-content">
                                    <p><b>ImageValidator</b> is a custom designed tool specifically to help you check images with greater certainty, consistency and accuracy.</p>
                                    <p>By using a reverse image search engine ImageValidator :</p>
                                    <ul>
                                        <li><p><b>Make better decisions</b></p>
                                        <p>Image Validator can be an optional upgrade to standard image checking interface to strengthen image checking skills.</p>
                                        </li>
                                        <li><p><b>Work faster</b></p>
                                        <p>Avoid duplicate effort by seeing the image decisions that were made previously on any new image reviewed.</p>
                                        </li>
                                        <li><p><b>Work smarter</b></p>
                                        <p>Access the internet to broaden your search for similar images as well as your own historic database.</p>
                                        </li>
                                        <li><p><b>Partner with an industry expert</b></p>
                                        <p>Search Thales’s comprehensive image database of recognisable images that are recommended to be denied.</p>
                                        </li>
                                        <li><p><b>Avoid Legal Complications</b></p>
                                        <p>Provide equal treatment of all image decisions by referencing past determination.</p>
                                        </li>
                                    </ul>
                                </div>
                            </AccordionItemPanel>
                        </AccordionItem>
                    </Accordion>
                </div>
            </div>
        )
    }
}

export default ImageValidator;